<template>
  <!-- Outgoing messages -->
  <div class="outgoing-chats">
    <div class="outgoing-chats-img">
      <img v-if="avatar" :src="`http://localhost:9000/story/${avatar}`" />
    </div>
    <div class="outgoing-msg">
      <div class="outgoing-chats-msg">
        <p class="multi-msg">
          {{ message.content }}
        </p>

        <span class="time">18:30 PM | July 24</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    "message",
  ],
  data() {
    return {
      avatar: this.$store.getters["profile/getAvatar"],
    };
  },
};
</script>

<style scoped>
p {
  overflow-wrap: break-word;
}

/* Styling the msg-sent time  */
.time {
  color: #777;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}

img {
  width: 50px;
  height: 50px;
  vertical-align: middle;
  border-style: none;
  border-radius: 100%;
}
.outgoing-chats {
  overflow: hidden;
  /* margin: 26px 20px; */
}

.outgoing-chats-msg p {
  background-color: #3a12ff;
  background-image: linear-gradient(
    45deg,
    #ee087f 0%,
    #dd2a7b 25%,
    #9858ac 50%,
    #8134af 75%,
    #515bd4 100%
  );
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  color: #fff;
  padding: 5px 10px 5px 12px;
  width: 100%;
  padding: 1rem;
  box-shadow: rgb(0 0 0 / 25%) 0px 2px 5px 2px;
}
.outgoing-chats-msg {
  float: right;
  width: 46%;
}

/* Styling the avatar */
.outgoing-chats-img {
  display: inline-block;
  width: 50px;
  float: right;
  margin-right: 1rem;
}

@media only screen and (max-device-width: 850px) {
  *,
  .time {
    font-size: 28px;
  }
  img {
    width: 65px;
  }
  .outgoing-chats-msg p {
    font-size: 28px;
  }
}

@media only screen and (max-device-width: 450px) {
  *,
  .time {
    font-size: 28px;
  }
  img {
    width: 65px;
  }
  .outgoing-chats-msg p {
    font-size: 28px;
  }
}
</style>